import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SearchResultCmsPageViewModel } from '@models/api.models';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { SetIsFocusedDirective } from '@shared/is-focused/is-focused.directive';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-search-content-results',
    templateUrl: './search-content-results.component.html',
    styleUrls: ['./search-content-results.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, SetIsFocusedDirective, RouterLink, TranslateModule]
})
export class SearchContentResultsComponent {
    @Input()
    contentResults: SearchResultCmsPageViewModel[];

    @Input()
    headline: string;

    @Input()
    showType?: boolean = false;
}
